"use strict";

var Autocomplete = {
  euBounds: undefined,
  optionTraveler: 1,
  optionDriver: 2,
  optionClient: 3,
  optionClientRestricted: 4,
  autocompleteClass: 'google-autocomplete',
  autocompleteClassDriver: 'google-autocomplete-driver',
  autocompleteClassClient: 'google-autocomplete-client',
  autocompleteOptionsForDriver: {
    types: ["geocode"],
    fields: ["name", "geometry.location", "place_id", "formatted_address", "address_component"]
  },
  autocompleteOptionsForClient: undefined,
  autocompleteOptionsForTraveler: {
    types: ["(cities)"],
    fields: ["name", "geometry.location", "place_id", "formatted_address", "address_component"]
  },
  onload: document.addEventListener('DOMContentLoaded', function () {
    Autocomplete.init();
  }),
  init: function init() {
    Autocomplete.euBounds = new google.maps.LatLngBounds(new google.maps.LatLng(35.808593, -32.265625), new google.maps.LatLng(70.020587, 39.023438));
    Autocomplete.autocompleteOptionsForClient = {
      bounds: Autocomplete.euBounds,
      types: ["geocode"],
      fields: ["name", "geometry.location", "place_id", "formatted_address", "address_component"],
      strictBounds: true
    };
    this.bind();
    this.googleAutocomplete.autocompleteField();
  },
  bind: function bind() {},
  googleAutocomplete: {
    autocompleteField: function autocompleteField() {
      $('.' + Autocomplete.autocompleteClass).each(function (index) {
        var fieldId = $(this).attr('id');
        var autocomplete = new google.maps.places.Autocomplete(document.getElementById(fieldId), Autocomplete.getOptions(Autocomplete.optionTraveler));
        var locationInfo = {
          geo: null,
          country: null,
          state: null,
          city: null,
          postalCode: null,
          street: null,
          streetNumber: null,
          reset: function reset() {
            this.geo = null;
            this.country = null;
            this.state = null;
            this.city = null;
            this.postalCode = null;
            this.street = null;
            this.streetNumber = null;
          }
        };

        // I haven't found a better way to disable the browser autocomplete for address
        $(this).attr('autocomplete', Math.random());
        google.maps.event.addListener(autocomplete, "place_changed", function () {
          var place = autocomplete.getPlace();
          var address = place.address_components;
          var lat = place.geometry.location.lat();
          var lng = place.geometry.location.lng();
          locationInfo.reset();
          locationInfo.geo = [lat, lng];
          $('[name="travel_coordinates_lng_from"]').val(lat);
          $('[name="travel_coordinates_lat_from"]').val(lng);
          for (var i = 0; i < address.length; i++) {
            var component = address[i].types[0];
            switch (component) {
              case "country":
                locationInfo.country = address[i]["long_name"];
                break;
              case "administrative_area_level_1":
                locationInfo.state = address[i]["long_name"];
                break;
              case "locality":
                locationInfo.city = address[i]["long_name"];
                break;
              case "postal_code":
                locationInfo.postalCode = address[i]["long_name"];
                break;
              case "route":
                locationInfo.street = address[i]["long_name"];
                break;
              case "street_number":
                locationInfo.streetNumber = address[i]["long_name"];
                break;
              default:
                break;
            }
          }
          $('[name="travel_country_from"]').val(locationInfo.country);
          $('[name="travel_city_from"]').val(locationInfo.city);
          $('[name="travel_street_from"]').val(locationInfo.postalCode);
          $('[name="travel_postal_code_from"]').val(locationInfo.street);
          console.log('locationInfo', JSON.stringify(locationInfo, null, 4));
        });
      });
      setTimeout(function () {
        $('.' + Autocomplete.autocompleteClass).attr('autocomplete', Math.random());
      }, 100);
    }
  },
  googleAutocompleteForDriver: {
    autocompleteField: function autocompleteField() {
      $('.' + Autocomplete.autocompleteClassDriver).each(function (index) {
        var field = $(this);
        var fieldId = field.attr('id');
        var autocomplete = new google.maps.places.Autocomplete(document.getElementById(fieldId), Autocomplete.getOptions(Autocomplete.optionDriver));
        var locationInfo = {
          geo: '',
          country: '',
          state: '',
          city: '',
          postalCode: '',
          street: '',
          streetNumber: '',
          reset: function reset() {
            this.geo = '';
            this.country = '';
            this.state = '';
            this.city = '';
            this.postalCode = '';
            this.street = '';
          }
        };
        google.maps.event.addListener(autocomplete, "place_changed", function () {
          var place = autocomplete.getPlace();
          var address = place.address_components;
          var lat = place.geometry.location.lat();
          var lng = place.geometry.location.lng();
          locationInfo.reset();
          locationInfo.geo = [lat, lng];
          $('[name="driver_lat"]').val(lat);
          $('[name="driver_lng"]').val(lng);
          $('[name="lat"]').val(lat);
          $('[name="lng"]').val(lng);
          $('[name="sh"]').val(lat);
          $('[name="d"]').val(lng);
          for (var i = 0; i < address.length; i++) {
            var component = address[i].types[0];
            var value = address[i]["long_name"];
            switch (component) {
              case "country":
                locationInfo.country = value;
                break;
              case "administrative_area_level_1":
                locationInfo.state = value;
                break;
              case "locality":
                locationInfo.city = value;
                break;
              case "postal_code":
                locationInfo.postalCode = value;
                break;
              case "route":
                locationInfo.street = value;
                break;
              case "street_number":
                locationInfo.streetNumber = value;
                break;
              default:
                break;
            }
          }
          $('[name="driver_country"]').val(locationInfo.country);
          $('[name="driver_city"]').val(locationInfo.city);
          $('[name="city"]').val(locationInfo.city);
          $('[name="driver_postal_code"]').val(locationInfo.postalCode);
          $('[name="driver_street"]').val(locationInfo.street);
          if (locationInfo.city === '') {
            field.val('');
            field.closest('.form-step__input').find('.form-step__error').show().text('Please enter a valid city');
            setTimeout(function () {
              field.parent().find('.form-step__error').text('').hide();
            }, 3000);
          }
          console.log('locationInfo', JSON.stringify(locationInfo, null, 4));
        });
      });
      setTimeout(function () {
        $('.' + Autocomplete.autocompleteClassDriver).attr('autocomplete', Math.random());
      }, 100);
    }
  },
  googleAutocompleteForClient: {
    autocompleteField: function autocompleteField() {
      $('.' + Autocomplete.autocompleteClassClient).each(function (index) {
        var field = $(this);
        var fieldId = field.attr('id');
        var options = {};
        if (parseInt(field.attr('data-type')) === 9) {
          options = {
            types: ["geocode", "establishment"],
            fields: ["name", "geometry.location", "place_id", "formatted_address", "address_component"],
            componentRestrictions: {
              country: $('[name="find-task-options-country-checkbox"]:checked').val()
            }
          };
        } else {
          options = Autocomplete.getOptions(Autocomplete.optionClient);
        }
        var autocomplete = new google.maps.places.Autocomplete(document.getElementById(fieldId), options);
        var locationInfo = {
          geo: '',
          country: '',
          state: '',
          city: '',
          postalCode: '',
          street: '',
          streetNumber: '',
          reset: function reset() {
            this.geo = '';
            this.country = '';
            this.state = '';
            this.city = '';
            this.postalCode = '';
            this.street = '';
          }
        };
        google.maps.event.addListener(autocomplete, "place_changed", function () {
          var place = autocomplete.getPlace();
          var address = place.address_components;
          var lat = place.geometry.location.lat();
          var lng = place.geometry.location.lng();
          locationInfo.reset();
          locationInfo.geo = [lat, lng];
          if (parseInt(field.attr('data-type')) === 2) {
            $('[name="client_lat"]').val(lat);
            $('[name="client_lng"]').val(lng);
          } else if (parseInt(field.attr('data-type')) === 3) {
            $('[name="calculator-lat"]').val(lat);
            $('[name="calculator-lng"]').val(lng);
          } else if (parseInt(field.attr('data-type')) === 5) {
            $('[name="businessLatFrom"]').val(lat);
            $('[name="businessLngFrom"]').val(lng);
            Business.pointStart = {
              lat: lat,
              lng: lng
            };
            Business.calcRoute();
          } else if (parseInt(field.attr('data-type')) === 6) {
            $('[name="businessLatTo"]').val(lat);
            $('[name="businessLngTo"]').val(lng);
            Business.pointFinish = {
              lat: lat,
              lng: lng
            };
            Business.calcRoute();
          } else if (parseInt(field.attr('data-type')) === 7) {
            $('[name="sh_f"]').val(lat);
            $('[name="d_f"]').val(lng);
          } else if (parseInt(field.attr('data-type')) === 8) {
            $('[name="sh_t"]').val(lat);
            $('[name="d_t"]').val(lng);
          } else if (parseInt(field.attr('data-type')) === 9) {
            $('[name="find-task-options-lat"]').val(lat);
            $('[name="find-task-options-lng"]').val(lng);
          } else {
            $('[name="client_lat_to"]').val(lat);
            $('[name="client_lng_to"]').val(lng);
          }
          $('[name="lat"]').val(lat);
          $('[name="lng"]').val(lng);
          $('[name="sh"]').val(lat);
          $('[name="d"]').val(lng);
          for (var i = 0; i < address.length; i++) {
            var component = address[i].types[0];
            var value = address[i]["long_name"];
            switch (component) {
              case "country":
                locationInfo.country = value;
                break;
              case "administrative_area_level_1":
                locationInfo.state = value;
                break;
              case "locality":
                locationInfo.city = value;
                break;
              case "postal_code":
                locationInfo.postalCode = value;
                break;
              case "route":
                locationInfo.street = value;
                break;
              case "street_number":
                locationInfo.streetNumber = value;
                break;
              default:
                break;
            }
          }
          var dataType = parseInt(field.attr('data-type'));
          if (dataType === 2) {
            $('[name="client_country"]').val(locationInfo.country);
            $('[name="client_city"]').val(locationInfo.city);
            $('[name="client_postal_code"]').val(locationInfo.postalCode);
            $('[name="client_street"]').val(locationInfo.street);
          } else if (dataType === 3) {
            $('[name="calculator-country-from"]').val(locationInfo.country);
          } else if (dataType === 4) {
            $('[name="calculator-country-to"]').val(locationInfo.country);
          } else if (dataType === 5) {
            $('[name="businessCountryFrom"]').val(locationInfo.country);
            $('[name="businessCityFrom"]').val(locationInfo.city);
          } else if (dataType === 6) {
            $('[name="businessCountryTo"]').val(locationInfo.country);
            $('[name="businessCityTo"]').val(locationInfo.city);
          } else if (parseInt(field.attr('data-type')) === 9) {
            $('[name="find-task-options-city"]').val(locationInfo.city);
          } else {
            $('[name="client_country_to"]').val(locationInfo.country);
            $('[name="client_city_to"]').val(locationInfo.city);
            $('[name="client_street_to"]').val(locationInfo.postalCode);
            $('[name="client_postal_code_to"]').val(locationInfo.street);
          }
          if (locationInfo.city === '') {
            field.val('');
            field.closest('.form-step__input').find('.form-step__error').show().text('Please enter a valid city');
            setTimeout(function () {
              field.parent().find('.form-step__error').text('').hide();
            }, 3000);
          }
          console.log('locationInfo', JSON.stringify(locationInfo, null, 4));
        });
      });

      // I haven't found a better way to disable the browser autocomplete for address
      setTimeout(function () {
        $('.' + Autocomplete.autocompleteClassClient).attr('autocomplete', Math.random());
      }, 150);
    }
  },
  getOptions: function getOptions(type) {
    switch (type) {
      case Autocomplete.optionDriver:
        return Autocomplete.autocompleteOptionsForDriver;
      case Autocomplete.optionClient:
        return Autocomplete.autocompleteOptionsForClient;
      case Autocomplete.optionTraveler:
        return Autocomplete.autocompleteOptionsForTraveler;
      default:
        break;
    }
  }
};